<template>
    <a-modal
            :width="'50%'"
            v-model="entityUpload"
            :key="$t('supervise.importEntitys')"
            :maskClosable="maskClosable"
            destroyOnClose
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="form">
                    <a-form-item :label="$t('supervise.superviseOrg')" v-bind="formItemLayout">
                        <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.group')" v-bind="formItemLayout">
                        <a-select  v-model="groupId" size="small" v-decorator="['groupId',{ rules: [{ required: true, message: $t('global.isRequired') }] }] ">
                            <a-select-option v-for="group in groups" :key="group.groupId" >{{group.groupName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>

                <a-row :gutter="24">
                    <a-col :xs="{span:20}" :sm="{span:3}"></a-col>
                    <a-col :xs="{span:24}" :sm="{span:16}">
                        <a-upload
                                :action="uploadUrl"
                                :format="['xlsx']"
                                :beforeUpload="beforeUpload"
                                :showUploadList="false"
                                @change="handleChange"
                                :headers="token">
                            <a-button size="small" type="primary">
                                <a-icon type="upload" style="padding-right:4px"/>
                                {{$t('global.import')}}
                            </a-button>
                        </a-upload>

                        <a-button size="small" style="margin-top:10px;margin-left:10px" @click="downloadExample">
                            <a-icon type="download" style="padding-right:4px"/>
                            {{$t('supervise.downloadTemplate')}}
                        </a-button>
                    </a-col>
                </a-row>

                <a-table style="margin-top:25px" :scroll="{ x: 800 }" :columns="columns" :dataSource="data" :pagination="pagination">
                </a-table>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import {export_json_to_excel} from '@/utils/Export2Excel'
    import moment from 'moment'
    import {trimData} from '../../utils/formFunctions'

    export default {
        name: 'ZUploadEntity',
        data() {
            return{
                pagination:{pageSize: 5,showTotal:this.showTotal,},
                uploadUrl:config.api.entity_upload_url,
                maskClosable: false,
                entityUpload: false,
                form: null,
                fields: [],
                groupId: null,
                groups: [],
                token: {},
                columns: [],
                data:[],
                orgOption:{
                    id: "uploadEntityOrg",
                    value: ""
                },
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    },
                }
            }
        },
        components: {
            ZOrgChooser
        },
        created() {
            this.token = {Authorization:'Bearer ' + this.$store.getters.token}
        },
        methods: {
            showTotal(total){
                return this.$t('global.totalRecords', {num: total})
            },
            beforeUpload (file) {
                // console.log(file)
                if(file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                    this.$message.error(this.$t('global.checkXlsx'))
                    return false
                }
                return true
            },
            downloadExample(){
                let tHeader = []
                let exportData = []
                let data = []
                this.fields.map((item) => {
                    let title = item.name
                    if(item.inputType == 'selectBox'){
                        title += this.$t('supervise.selectedValue', {data: item.dataSource})
                    }
                    if(item.inputType == 'date'){
                        let date = moment().format('YYYY/MM/DD');
                        title += '(YYYY/MM/DD' + date + ')'
                    }
                    if (item.inputType === 'image') {
                        title = ''
                    }
                    if (item.isRequire) {
                        title += `(${this.$t('global.isRequired')})`
                    }
                    if (title) {
                        tHeader.push(title)
                        data.push('XXX')
                    }
                })
                exportData.push(data)
                export_json_to_excel(tHeader, exportData, this.$t('supervise.entityTemplate'))
            },
            handleChange(info) {
                // console.log(info)
                if (info.file.status === 'done') {
                    let data = trimData(info.file.response.result)
                    // console.log(data)
                    if (data.length > 0) {
                        // console.log(data)
                        // console.log(this.fields)
                        let res = this.checkHasRequiredValue(data)
                        // console.log(res)
                        if (res.statu === true) {
                            this.data = data
                        } else {
                           this.$message.error(res.msg) 
                        }
                    } else {
                        this.$message.error('未导入任何内容')
                    }
                }
            },
            checkHasRequiredValue (data) {
                let res
                // 遍历导入的数据
                for (let i = 0; i< data.length; i++) {
                    // 获取每一条数据的keys
                    let keys = Object.keys(data[i])
                    // console.log(keys)
                    // 遍历每一条数据的key
                    for (let j = 0; j < keys.length; j++) {
                        // 如果这个key并不存在于模板字段中，那说明用户上传了非法模板
                        let hasThisKey = this.fields.some((item) => {
                            // console.log(keys[j])
                            // console.log(item.name)
                            return item.name === keys[j]
                        })
                        if (!hasThisKey) {
                            return {
                                statu: false,
                                msg: '导入了非法模板'
                            }
                        }
                    }
                    let requiredNames = this.fields.filter((item) => {
                        return item.isRequire === true
                    })
                    // console.log(requiredNames)
                    let objKey
                    for (let k = 0; k < requiredNames.length; k++) {
                        objKey = requiredNames[k].name
                        // console.log(i)
                        // console.log(data[i][objKey])
                        if (!data[i][objKey]) {
                            // console.log(k)
                            return {
                                statu: false,
                                msg: `第${i + 1}行的必填项${objKey}缺失，请修改后提交！`
                            }
                        }
                    }
                }
                return {
                    statu: true
                }
            },
            handleOk() {
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        // console.log(values)
                        if(this.data.length == 0){
                            this.$message.error('尚未添加实体')
                            return
                        }else{
                            let params = []
                            let _this = this
                            this.data.map((item) => {
                                let param = {}
                                param.attrs = item
                                param.entityGroupId = _this.groupId
                                for(var key in param.attrs){
                                    this.fields.map((field) =>{
                                        if(key == field.name && field.inputType == 'date'){
                                            if(param.attrs[key]){
                                                var year = param.attrs[key].split('-')[0]
                                                var month = param.attrs[key].split('-')[1]
                                                var day = param.attrs[key].split('-')[2]
                                                var date = new Date()
                                                date.setYear(year)
                                                date.setMonth(month)
                                                date.setDate(day)
                                                param.attrs[key] = (date.getTime() / 1000).toFixed(0);
                                            }
                                        }
                                    })
                                }
                                params.push(param)

                            })
                            // console.log(params)
                            this.$http.post(config.api.entity_url + "/" + this.orgId,params).then((response) => {
                                if(response.code == 0){
                                    this.$message.success('导入实体成功')
                                    this.$emit('success');
                                    this.entityUpload = false
                                } else {
                                    this.$message.error(response.desc)
                                }
                            })
                        }
                    }
                })
            },
            onOrgSelect(org){
                this.orgId = org.id
                if(this.fields.length == 0){
                    this.$http.get(config.api.entity_template_org_url + "/" + org.id).then((response) => {
                        if(response.code == 0){
                            this.fields = response.result.attrs
                            this.data = []
                            this.columns = []
                            let _this = this

                            this.fields.map(function(item){
                                _this.columns.push(
                                    {
                                        title: item.name,
                                        dataIndex: item.name,
                                        key: item.name
                                    }
                                )
                            })
                        }
                    })
                }
                this.groupId = org.defaultEntityGroupId
                this.form.setFieldsValue({
                    groupId: org.defaultEntityGroupId
                });

                this.$http.get(config.api.entity_group_summary_url + '/' + org.id).then((response) => {
                    if(response.code == 0){
                        this.groups = response.result
                    }
                })
            },
            showModel(){
                this.entityUpload = true
                this.form = this.$form.createForm(this)
                if(this.$refs["orgChooser"]){
                    this.$refs["orgChooser"].initOrgTree()
                }
                this.data = []
            }
        }
    }
</script>